import React   from "react";

const BtnSubir = () => {
    const subirPantalla = () => {
        window.scrollTo(0, 0)
    }

    return (
        <div className="btn-subir">
            <button onClick={subirPantalla}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <path id="___SVG_ID__0__0___" d="M11.249,8.581v10h2.087v-10l4.481,4.481,1.476-1.476-7-7-7,7,1.476,1.476Z" transform="translate(-5.293 -4.586)" fill="#000000"></path>
                </svg>
            </button>
        </div>
    );
};

export default BtnSubir;
